import { render } from "./recovery-form.vue?vue&type=template&id=8fc7316c"
import script from "./recovery-form.vue?vue&type=script&lang=ts"
export * from "./recovery-form.vue?vue&type=script&lang=ts"
script.render = render

export default script